// Korean — top-level translations. Falls back to English for missing keys.
import en from "./en";

const ko = {
  ...en,
  ui: {
    ...en.ui,
    brand: "My World Quest",
    brand_subtitle: "색칠하고 배우기",
    nav: {
      home: "홈", countries: "나라", globe: "지구", continents: "대륙",
      color: "색칠", puzzles: "퍼즐", games: "게임", math: "지리 수학",
      quiz: "퀴즈", parents: "부모님", more: "더보기",
     "geo-lines": "세계 선", "maths-academy": "수학 아카데미",},
    accessibility: { bigText: "큰 글씨", highContrast: "고대비" },
    navGroups: { quick: "빠른", explore: "탐험", play: "놀고 배우기", collect: "수집", adv: "모험", grownup: "어른용" },
    actions: { back: "뒤로", close: "닫기", reset: "초기화", save: "저장", retry: "다시", playAgain: "다시 놀기" },
  },
  microcopy: {
    ...en.microcopy,
    great: "잘했어요! ⭐",
    correct: "✅ 정답!",
    nope: "다시 해봐요!",
    tryAgain: "거의 다 왔어요!",
    awesome: "멋져요!",
    welcome: "{{country}}에 오신 것을 환영해요! {{language}}를 배워봐요.",
    youDidIt: "해냈어요!",
    perfect: "완벽!",
  },
  home: {
    ...en.home,
    title1: "세계를 탐험하자",
    title2: "한 번에 한 나라씩",
    subtitle: "재미있는 지리 모험, 퀴즈, 도전 및 보상으로 아이들이 나라, 문화, 깃발, 랜드마크 등을 발견할 수 있도록 도와줍니다.",
    playNow: "지금 놀기 →",
    takeQuiz: "퀴즈 풀기",
    openGlobe: "큰 지구본 열기 →",
    globeHint: "빛나는 핀을 눌러 나라를 배워요!",
    popularCountries: "또는 국기를 눌러요",
    whatNext: "오늘은 뭐 할래요?",
    whatNextSub: "마음대로 골라요. 다 재미있어요!",
    tiles: {
      ...en.home.tiles,
      learn: "나라 배우기", learnDesc: "30개 나라의 국기!",
      globe: "3D 지구", globeDesc: "돌리고 눌러봐요",
      continents: "대륙", continentsDesc: "7대륙 탐험",
      color: "랜드마크 색칠", colorDesc: "에펠탑을 색칠해요!",
      math: "지리 수학", mathDesc: "km 더하기, 나라 세기!",
      quiz: "퀴즈 시간", quizDesc: "기본과 심화",
      parents: "부모님용", parentsDesc: "아이의 성장 보기",
    },
  },
  learn: {
    title: "나라 배우기", capital: "수도", language: "언어", hello: "안녕",
    learnIt: "배웠어요!", listen: "들어보기",
    goalsEyebrow: "오늘의 학습 목표",
    goalsHeading: "🎯 이것부터 집중해요",
    goalsSubtitle: "{{tier}}세에 꼭 마스터해야 할 네 가지 — 교과 과정에서 선정.",
    goalsAllTopics: "모든 주제 보기",
    goalsLearnNow: "지금 배우기",
    goalsKey: "핵심 #{{n}}",
    topicTitles: {
      "art-design": "그림, 물감과 디자인",
      "music": "음악: 리듬, 노래, 악보",
      "computing-code": "코딩, 알고리즘, 사이버 안전",
      "physical-education": "체육, 건강, 운동",
      "world-religions": "세계 종교와 신념",
      "wellbeing-relationships": "건강, 감정, 우정",
    },
  },
  globe: {
    title: "3D 지구", subtitle: "돌리고 눌러봐요",
    learnLang: "언어 배우기", moreInfo: "더 보기", learnedTag: "✓ 배움",
    spinTap: "지구를 돌려서 나라를 눌러봐요!", spinTapSub: "핀을 눌러 더 알아봐요.",
  },
  quiz: {
    title: "퀴즈", basic: "기본", advanced: "심화",
    start: "퀴즈 시작", next: "다음 →", finish: "완료!", score: "점수",
  },
  stickers: { title: "나의 스티커 앨범", subtitle: "모든 활동에서 스티커를 모아요!" },
  langSwitcher: {
    label: "언어",
    english: "English", french: "Français", hindi: "हिन्दी", arabic: "العربية",
    italian: "Italiano", spanish: "Español", mandarin: "中文", japanese: "日本語", korean: "한국어", swahili: "Kiswahili",
  },
  common: {
    whereToNext: "다음은 어디로?",
    home: "홈",
    earnMoreStars: "⭐ 더 많은 별 받기",
    earnHowTo: "빠른 게임을 해 봐 — 각각 XP를 줘!",
    pickAge: "나이 선택",
    ages: "나이",
    startExploring: "탐험 시작",
    pickAnywhere: "위에서 선택해 — 아니면 여기를 눌러!",
    tapAnyCountry: "나라를 눌러 이야기를 알아보세요!",
    exploreGlobe: "지구 탐험",
    exploreGlobeSub: "풀스크린 3D 모험",
  },
  shortcuts: {
    home: "홈",
    continents: "대륙",
    globe: "지구본",
    ask: "물어보기",
    landmarks: "명소",
    flags: "국기",
    pixel: "픽셀",
    puzzles: "퍼즐",
    math: "수학",
    trip: "여행",
    quiz: "퀴즈",
    quests: "퀘스트",
    stickers: "스티커",
    miniGames: "미니게임",
    geoMath: "지리 수학",
    quickQuiz: "빠른 퀴즈",
    myTrophies: "내 트로피",
    colorCreate: "색칠 & 만들기",
    spinGlobe: "지구본 돌리기",
    askGlobe: "지구에게 물어봐",
    dreamTrip: "꿈의 여행",
    earnStars: "별 모으기",
    tryAQuest: "퀘스트 도전",
    playAgain: "다시 하기",
    learnCountry: "나라 배우기",
    colorLandmark: "명소 색칠",
    learnCountries: "나라 배우기",
    advanced: "고급 모드",
    spellCountry: "나라 철자 맞히기",
    advancedHub: "고급 모드",
    squishyHop: "스쿼시 홉",
    mathSnap: "매스 스냅",
    language: "언어",
    geoLines: "세계 선",
  },
  coloringExtra: {
    modeLandmarks: "명소",
    modeFlags: "국기 아티스트",
    modePixel: "픽셀 아트",
    diffEasy: "쉬움",
    diffMedium: "보통",
    diffExpert: "전문가",
    difficultyLabel: "난이도:",
  },
  tilesExtra: {
    labelLearn: "배우기",
    labelCreate: "만들기",
    labelPlay: "놀기",
    labelTrophies: "트로피",
    whatNextSub: "원하는 거 고르기 — 다 재밌어요!",
  },
  pills: {
    orTry: "또는 ↓",
    
    squishyHop: "스쿼시 호프",
    mathSnap: "수학 스냅",colorLandmark: "명소 색칠하기",
    solvePuzzle: "퍼즐 풀기",
    dreamTrip: "꿈의 여행 계획",
    geoMath: "지리 수학",
    continentQuests: "대륙 퀘스트",
    stickerBook: "스티커북",
    famousPeople: "유명인 만나기",
    culturalSpot: "문화 스폿",
    quickQuiz: "빠른 퀴즈",
    continentMaps: "대륙 지도",
    spellCountry: "나라 철자 맞히기",
    flagArtist: "국기 아티스트",
    pixelArt: "픽셀 아트",
    spinGlobe: "지구본 돌리기",
    askGlobe: "지구에게 물어봐",
    myTrophies: "내 트로피",
    advancedHub: "고급 모드",
    geoLines: "세계 선",
  },
  canvas: {
    tools: "도구",
    brushSize: "붓 크기",
    colors: "색",
    patterns: "패턴",
    modes: "모드",
    solid: "단색",
    anyColor: "다른 색",
    recent: "최근",
    sticker: "스티커",
    symmetry: "대칭",
    colorByNumber: "숫자로 색칠",
    reference: "참고",
    undo: "되돌리기",
    redo: "다시",
    reset: "초기화",
    replay: "다시 보기",
    check: "확인",
    save: "저장",
    fill: "채우기",
    pencil: "연필",
    stamp: "스탬프",
    erase: "지우기",
    on: "ON",
    off: "OFF",
    tool: "도구:",
    pattern: "패턴:",
    printOne: "인쇄",
    downloadAll: "모두 다운로드",
    appTitle: "색칠 & 만들기 🎨",
    appSub: "붓, 패턴, 스티커, 숫자로 색칠 등!",
  },
};

export default ko;
